import { PhShoppingCartSimple } from '@phosphor-icons/vue'

import { type BuilderBlockModule } from '@/lib/builder/types'
import i18nPlugin from '@/plugins/i18n'

import {
  type CampaignResource,
  type CTAButtonSection,
  type CTAButtonSectionCreate,
  type CTAButtonSectionUpdate,
} from '../../types'
import { emailBlockMethods } from '../common/methods'

import { createCTAButtonData } from './methods/createCTAData'
import CTAButtonPreview from './preview/CTAButtonPreview.vue'
const i18n = i18nPlugin.global

export const CTAButtonBlockModule: BuilderBlockModule<
  CTAButtonSection,
  CTAButtonSectionCreate,
  CTAButtonSectionUpdate,
  CampaignResource
> = {
  canAdd: true,
  canDelete: true,
  canReorderDown: true,
  canReorderUp: true,
  createData: createCTAButtonData,
  meta: [
    {
      icon: PhShoppingCartSimple,
      key: 'cta',
      label: i18n.t('email-builder.blocks.cta-section'),
    },
  ],
  methods: emailBlockMethods,
  preview: CTAButtonPreview,
}
